// CuttingPage.jsx
import React, { useState } from "react";
import CompanyTabs from "./CompanyTabs";
import CuttingSheetsPanel from "./CuttingSheetsPanel";

export default function CuttingPage() {
  const [activeCompany, setActiveCompany] = useState(null);
  const [activeSheetsTab, setActiveSheetsTab] = useState("current"); // current | completed

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between">
        <h3 className="mb-3 ms-3">Листы на резку</h3>
      </div>

      <CompanyTabs 
        activeCompany={activeCompany} 
        setActiveCompany={setActiveCompany} 
      />

      {activeCompany && (
        <CuttingSheetsPanel
          activeTab={activeSheetsTab}
          setActiveTab={setActiveSheetsTab}
          companyId={activeCompany}
        />
      )}
    </div>
  );
}